// extracted by mini-css-extract-plugin
export default {"logoCard":"IconItem_logoCard__3txyp","logoItems":"IconItem_logoItems__+GPi6"};